import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';


@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['confirmation.component.css']
})
export class ConfirmationComponent implements OnInit {
  amount;
  username$;
  idNumber$;
  constructor() {

  }

  ngOnInit() {

  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/confirmation/confirmation.component.ts